import { buildModelsActionCreator } from '../actions';

export const FETCH_FORGOT_PASSWORD_MODEL = 'epic.model.FETCH_FORGOT_PASSWORD_MODEL';

export type FetchForgotPasswordAction = ReturnType<typeof fetchForgotPasswordModel>;

export const fetchForgotPasswordModel = buildModelsActionCreator(FETCH_FORGOT_PASSWORD_MODEL, 'forgotPassword');
